import { useEffect } from "react";

import { FieldOption } from "components/FieldSelect/FieldSelect";

type Params<T, WizardData extends Record<string, unknown>> = {
	currentOptions: FieldOption[];
	checker: (arg: unknown) => arg is T;
	enableProgressToNextStep: (newData: { [x: string]: T }) => void;
	wizardDataKey: keyof WizardData;
	disableProgressToNextStep: () => void;
};

export function useProgressWhenSelected<
	T,
	WizardData extends Record<string, unknown>
>({
	currentOptions,
	checker,
	enableProgressToNextStep,
	disableProgressToNextStep,
	wizardDataKey
}: Params<T, WizardData>) {
	useEffect(() => {
		const selectedOption = currentOptions.find(opt => !!opt.selected);
		const selectedOptionValue = selectedOption
			? selectedOption.value
			: undefined;

		if (selectedOptionValue !== undefined && checker(selectedOptionValue)) {
			const newWizardData = {
				[wizardDataKey]: selectedOptionValue
			};
			enableProgressToNextStep(newWizardData);
		} else {
			disableProgressToNextStep();
		}
	}, [
		enableProgressToNextStep,
		disableProgressToNextStep,
		currentOptions,
		checker,
		wizardDataKey
	]);
}
